/**
 *
 * Select Date for scheduled sending
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
//  import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import FormModal from 'components/interaction/FormModal/index.jsx';
import { addHours, startOfHour } from 'utils/date-fns/index.js';
import messages from './messages.js';
import schema from './dateForm.js';

function SelectDate(props) {
  const { onChange, onHide, value } = props;

  function handleSubmit(values) {
    onChange(values.scheduled);
    onHide();
  }

  function handleClear() {
    onChange(null);
    onHide();
  }

  const values = { scheduled: value || addHours(startOfHour(new Date()), 1) };
  return (
    <FormModal
      show
      onHide={onHide}
      onSubmit={handleSubmit}
      defaultValues={values}
      schema={schema}
      title={messages.schedulePost}
    >
      {value && (
        <Button className="float-end" onClick={handleClear} variant="danger">
          <FormattedMessage {...messages.dropSchedule} />
        </Button>
      )}
      <p className="help-block">
        <FormattedMessage {...messages.scheduleHelp} />
      </p>
    </FormModal>
  );
}

SelectDate.propTypes = {
  value: PropTypes.object,
  onHide: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectDate;
